export const getCurrentTimeZone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/** Formats an ISO timestamp into a locale-aware 12h time string, e.g. "01:15 p.m".
 * Uses the mark's timezone (from user's device at mark time) to ensure the displayed
 * time matches what the user saw when they clocked in, even if viewed from another timezone. */
export const formatMarkTime = (
  isoTimestamp: string,
  timezone: string,
  locale = 'es',
): string =>
  new Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(new Date(isoTimestamp));

type TFormatDateTimeArgs = {
  isoDateStr: string;
  languageCode: string;
  timeZone: string;
};

/** Formats an ISO date string into locale-aware date and time strings.
 * dateStr example: "4 de diciembre, 2025"
 * timeStr example: "01:15 p.m." */
export const formatDateTime = ({
  isoDateStr,
  languageCode,
  timeZone,
}: TFormatDateTimeArgs): { dateStr: string; timeStr: string } => {
  const date = new Date(isoDateStr);

  const dateStr = new Intl.DateTimeFormat(languageCode, {
    timeZone,
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);

  const timeStr = formatMarkTime(isoDateStr, timeZone, languageCode);

  return { dateStr, timeStr };
};

/**
 * Returns the today's date in the format "YYYY-MM-DD".
 */
export const getTodayDate = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
